export const summarizeAuditTrailCommentMessage = (message: string): string =>
  message
    .replace(/@\[(.*?)\]\((.*?)\)/g, '@$1')
    .replace(/\s+/g, ' ')
    .trim()
